export default async function checkAuth({ next }) {
  if (localStorage.getItem("token_signage")) {
    next();
  } else next("/auth/setup");
}
